export default "__VITE_ASSET__387c5bf1__"